import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { useOpenedRoomId } from '$logic/opened-room'
import { PendingUpload } from './types'
import { RootState } from '$setup/redux'

export function usePendingUploads() {
  return useSelector(
    (state: RootState) => state.main.pendingUploads as PendingUpload[],
  )
}

export function useOpenedRoomPendingUploads() {
  const roomId = useOpenedRoomId()
  return useRoomPendingUploadsById(roomId)
}

const memoizedSelector = R.memoizeWith(
  (roomId: string) => roomId,
  roomId => (state: RootState) =>
    (state.main.pendingUploads as PendingUpload[]).filter(
      ({ roomId: pendingUploadRoomId }) => pendingUploadRoomId === roomId,
    ),
)
const hashPendingUploads = (items: PendingUpload[]) =>
  items.map(upload => upload.id).join('')
const comparePendingUploads = (
  current: PendingUpload[],
  next: PendingUpload[],
) => hashPendingUploads(current) === hashPendingUploads(next)

export function useRoomPendingUploadsById(roomId: string = '') {
  return useSelector(memoizedSelector(roomId), comparePendingUploads)
}
